import { Navigate, Outlet, useLocation } from 'react-router-dom';

import ErrorAlert from '@/client/components/data-display/ErrorAlert';
import Loading from '@/client/components/media/Loading';
import User from '@/client/services/api/User';
import { useAccessHelper } from '@/client/services/hooks/auth/useAccessHelper';
import { useAuthStore } from '@/client/services/state/authStore';
import { useQuery } from '@tanstack/react-query';

export default function EditAssignmentWrapper() {
  const { authConfig } = useAuthStore();
  const location = useLocation();
  const { allowance } = useAccessHelper();
  const { pathname } = location;
  const { user } = authConfig;
  const { _id: userId, role, is_manager: isManager, access_profile: accessProfile } = user;

  const { assignmentsCreate } = allowance;

  const isCreate = pathname.includes('create');
  const isEdit = pathname.includes('edit');

  const currentUserIsManager = isManager && role !== 'admin';

  const {
    data: managerConfiguration,
    isFetching: isManagerConfigurationFetching,
    isError: isManagerConfigurationError,
  } = useQuery({
    enabled: currentUserIsManager,
    queryKey: ['managerConfiguration', userId],
    queryFn: () => User.getManagerConfiguration(userId),
  });

  if (accessProfile?.permissions.admin.users.restricted_access) {
    window.location.replace('/pvt/#/overview/assignments');

    return null;
  }

  if (currentUserIsManager && isManagerConfigurationFetching) return <Loading />;

  if (currentUserIsManager && isManagerConfigurationError)
    return <ErrorAlert title="Error loading manager configuration" />;

  if (currentUserIsManager && managerConfiguration?.disable_assignments && isCreate)
    return <Navigate to="/explore" replace />;

  if (currentUserIsManager && managerConfiguration?.disable_assignment_edit && isEdit)
    return <Navigate to="/explore" replace />;

  if (!assignmentsCreate) return <Navigate to="/explore" replace />;

  return <Outlet />;
}
